var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Header"),
      _vm._v(" "),
      _c("div", { attrs: { id: "main" } }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c("h1", { staticClass: "project-name" }, [
              _vm._v(
                _vm._s(
                  _vm.project && _vm.project.Info ? _vm.project.Info.title : ""
                ) + "\n          "
              ),
              _c(
                "a",
                {
                  staticClass: "questions",
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.openSteps()
                    }
                  }
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: ["far", "question-circle"], size: "lg" }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _vm.validationMessages.length > 0
              ? _c(
                  "div",
                  { staticClass: "col-md-12" },
                  [
                    _c("h5", [
                      _vm._v(
                        "Projeto ainda possui dados pendentes. Verifique todos antes de publicá-lo."
                      )
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.validationMessages, function(validate, k) {
                      return _c(
                        "div",
                        {
                          key: k,
                          staticClass:
                            "alert alert-danger alert-dismissible fade show",
                          attrs: { role: "alert" }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(validate.msg) +
                              "\n          "
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "row",
              class: { scrollable: _vm.scrollPosition > 280 },
              attrs: { id: "form-project" }
            },
            [
              _vm.project
                ? _c(
                    "b-tabs",
                    {
                      attrs: { pills: "", vertical: "" },
                      on: {
                        input: function(index) {
                          return (_vm.currentTab = index)
                        }
                      },
                      model: {
                        value: _vm.currentTab,
                        callback: function($$v) {
                          _vm.currentTab = $$v
                        },
                        expression: "currentTab"
                      }
                    },
                    [
                      _c(
                        "b-tab",
                        {
                          staticClass: "form-config",
                          attrs: {
                            title: "Informações",
                            active: _vm.infoActive
                          }
                        },
                        [
                          _c("template", { slot: "title" }, [
                            _c("span", { staticClass: "step-0" }, [
                              _vm._v("Informações")
                            ])
                          ]),
                          _vm._v(" "),
                          _c("ProjectInfo", {
                            attrs: {
                              project: this.project,
                              validated: this.isValidated
                            },
                            on: {
                              showloading: function($event) {
                                _vm.loading = true
                              },
                              hideloading: function($event) {
                                _vm.loading = false
                              },
                              reload: function($event) {
                                return _vm.reloadProject()
                              }
                            }
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.user.UserId == _vm.project.UserId || _vm.user.isAdmin
                        ? _c(
                            "b-tab",
                            {
                              staticClass: "form-config",
                              attrs: { title: "Gestor" }
                            },
                            [
                              _c("template", { slot: "title" }, [
                                _c("span", { staticClass: "step-5" }, [
                                  _vm._v("Gestor")
                                ])
                              ]),
                              _vm._v(" "),
                              _c("ProjectManager", {
                                attrs: { project: this.project },
                                on: {
                                  showloading: function($event) {
                                    _vm.loading = true
                                  },
                                  hideloading: function($event) {
                                    _vm.loading = false
                                  },
                                  reload: function($event) {
                                    return _vm.reloadProject()
                                  }
                                }
                              })
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.user.UserId == _vm.project.UserId || _vm.user.isAdmin
                        ? _c(
                            "b-tab",
                            {
                              staticClass: "form-config",
                              attrs: { title: "Dados Bancários" }
                            },
                            [
                              _c("template", { slot: "title" }, [
                                _c("span", { staticClass: "step-6" }, [
                                  _vm._v("Dados Bancários")
                                ])
                              ]),
                              _vm._v(" "),
                              _c("ProjectBankInfo", {
                                attrs: { project: this.project },
                                on: {
                                  showloading: function($event) {
                                    _vm.loading = true
                                  },
                                  hideloading: function($event) {
                                    _vm.loading = false
                                  },
                                  reload: function($event) {
                                    return _vm.reloadProject()
                                  }
                                }
                              })
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.project &&
                      _vm.project.projectType != "event" &&
                      (_vm.user.UserId == _vm.project.UserId ||
                        _vm.user.isAdmin)
                        ? _c(
                            "b-tab",
                            {
                              staticClass: "form-config",
                              attrs: { title: "Meios de Pagamento" }
                            },
                            [
                              _c("template", { slot: "title" }, [
                                _c("span", { staticClass: "step-8" }, [
                                  _vm._v("Meios de Pagamento")
                                ])
                              ]),
                              _vm._v(" "),
                              _c("ProjectOther", {
                                attrs: { project: this.project },
                                on: {
                                  showloading: function($event) {
                                    _vm.loading = true
                                  },
                                  hideloading: function($event) {
                                    _vm.loading = false
                                  },
                                  reload: function($event) {
                                    return _vm.reloadProject()
                                  }
                                }
                              })
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.project &&
                      _vm.project.projectType != "event" &&
                      (_vm.user.UserId == _vm.project.UserId ||
                        _vm.user.isAdmin)
                        ? _c(
                            "b-tab",
                            { staticClass: "form-config" },
                            [
                              _c("template", { slot: "title" }, [
                                _c("span", { staticClass: "step-1" }, [
                                  _vm._v("Usuários")
                                ])
                              ]),
                              _vm._v(" "),
                              _c("ProjectUsers", {
                                attrs: { project: this.project },
                                on: {
                                  showloading: function($event) {
                                    _vm.loading = true
                                  },
                                  hideloading: function($event) {
                                    _vm.loading = false
                                  },
                                  reload: function($event) {
                                    return _vm.reloadProject()
                                  }
                                }
                              })
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-tab",
                        {
                          staticClass: "form-config",
                          attrs: { title: "Imagens" }
                        },
                        [
                          _c("template", { slot: "title" }, [
                            _c("span", { staticClass: "step-2" }, [
                              _vm._v("Imagens")
                            ])
                          ]),
                          _vm._v(" "),
                          _c("ProjectImages", {
                            attrs: { project: this.project },
                            on: {
                              showloading: function($event) {
                                _vm.loading = true
                              },
                              hideloading: function($event) {
                                _vm.loading = false
                              },
                              reload: function($event) {
                                return _vm.reloadProject()
                              }
                            }
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.project && _vm.project.projectType != "event"
                        ? _c(
                            "b-tab",
                            {
                              staticClass: "form-config",
                              attrs: {
                                title: "Atividades",
                                active: _vm.activitiesActive
                              }
                            },
                            [
                              _c("template", { slot: "title" }, [
                                _c("span", { staticClass: "step-2" }, [
                                  _vm._v("Atividades")
                                ])
                              ]),
                              _vm._v(" "),
                              _c("ProjectActivities", {
                                attrs: { project: this.project },
                                on: {
                                  showloading: function($event) {
                                    _vm.loading = true
                                  },
                                  hideloading: function($event) {
                                    _vm.loading = false
                                  },
                                  reload: function($event) {
                                    return _vm.reloadProject()
                                  }
                                }
                              })
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-tab",
                        {
                          staticClass: "form-config",
                          attrs: { title: "Doadores" }
                        },
                        [
                          _c("template", { slot: "title" }, [
                            _c("span", { staticClass: "step-3" }, [
                              _vm._v("Doadores")
                            ])
                          ]),
                          _vm._v(" "),
                          _c("ProjectDonations", {
                            attrs: { project: this.project },
                            on: {
                              showloading: function($event) {
                                _vm.loading = true
                              },
                              hideloading: function($event) {
                                _vm.loading = false
                              },
                              reload: function($event) {
                                return _vm.reloadProject()
                              }
                            }
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.project && _vm.project.projectType != "event"
                        ? _c(
                            "b-tab",
                            {
                              staticClass: "form-config",
                              attrs: { title: "Custos" }
                            },
                            [
                              _c("template", { slot: "title" }, [
                                _c("span", { staticClass: "step-4" }, [
                                  _vm._v("Custos")
                                ])
                              ]),
                              _vm._v(" "),
                              _c("ProjectCosts", {
                                attrs: { project: this.project },
                                on: {
                                  showloading: function($event) {
                                    _vm.loading = true
                                  },
                                  hideloading: function($event) {
                                    _vm.loading = false
                                  },
                                  reload: function($event) {
                                    return _vm.reloadProject()
                                  }
                                }
                              })
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.user.UserId == _vm.project.UserId || _vm.user.isAdmin
                        ? _c(
                            "b-tab",
                            {
                              staticClass: "form-config",
                              attrs: { title: "Extrato" }
                            },
                            [
                              _c("template", { slot: "title" }, [
                                _c("span", { staticClass: "step-7" }, [
                                  _vm._v("Extrato")
                                ])
                              ]),
                              _vm._v(" "),
                              _c("ProjectExtract", {
                                attrs: { project: this.project },
                                on: {
                                  showloading: function($event) {
                                    _vm.loading = true
                                  },
                                  hideloading: function($event) {
                                    _vm.loading = false
                                  },
                                  reload: function($event) {
                                    return _vm.reloadProject()
                                  }
                                }
                              })
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.project && _vm.project.projectType != "event"
                        ? _c(
                            "b-tab",
                            {
                              staticClass: "form-config",
                              attrs: { title: "Botão" }
                            },
                            [
                              _c("template", { slot: "title" }, [
                                _c("span", { staticClass: "step-9" }, [
                                  _vm._v("Botão")
                                ])
                              ]),
                              _vm._v(" "),
                              _c("ProjectButton", {
                                attrs: { project: this.project },
                                on: {
                                  showloading: function($event) {
                                    _vm.loading = true
                                  },
                                  hideloading: function($event) {
                                    _vm.loading = false
                                  },
                                  reload: function($event) {
                                    return _vm.reloadProject()
                                  }
                                }
                              })
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-tab",
                        {
                          staticClass: "form-config",
                          attrs: { title: "Mensagem" }
                        },
                        [
                          _c("template", { slot: "title" }, [
                            _c("span", { staticClass: "step-10" }, [
                              _vm._v("Mensagem")
                            ])
                          ]),
                          _vm._v(" "),
                          _c("ProjectDonationMessage", {
                            attrs: { project: this.project },
                            on: {
                              showloading: function($event) {
                                _vm.loading = true
                              },
                              hideloading: function($event) {
                                _vm.loading = false
                              },
                              reload: function($event) {
                                return _vm.reloadProject()
                              }
                            }
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.project && _vm.project.projectType != "event"
                        ? _c(
                            "b-tab",
                            {
                              staticClass: "form-config",
                              attrs: { title: "Métrica Social" }
                            },
                            [
                              _c("template", { slot: "title" }, [
                                _c("span", { staticClass: "step-11" }, [
                                  _vm._v("Métrica Social")
                                ])
                              ]),
                              _vm._v(" "),
                              _c("ProjectSocialMetrics", {
                                attrs: { project: this.project },
                                on: {
                                  showloading: function($event) {
                                    _vm.loading = true
                                  },
                                  hideloading: function($event) {
                                    _vm.loading = false
                                  },
                                  reload: function($event) {
                                    return _vm.reloadProject()
                                  }
                                }
                              })
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.project && _vm.project.projectType != "event"
                        ? _c(
                            "b-tab",
                            {
                              staticClass: "form-config",
                              attrs: { title: "Métrica Social" }
                            },
                            [
                              _c("template", { slot: "title" }, [
                                _c("span", { staticClass: "step-11" }, [
                                  _vm._v("Descontos do Bem")
                                ])
                              ]),
                              _vm._v(" "),
                              _c("ProjectLinkDescontos", {
                                attrs: { project: this.project },
                                on: {
                                  showloading: function($event) {
                                    _vm.loading = true
                                  },
                                  hideloading: function($event) {
                                    _vm.loading = false
                                  },
                                  reload: function($event) {
                                    return _vm.reloadProject()
                                  }
                                }
                              })
                            ],
                            2
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("Footer"),
      _vm._v(" "),
      _vm.loading ? _c("Loading") : _vm._e(),
      _vm._v(" "),
      _c("v-tour", {
        attrs: {
          name: "projectTour",
          steps: _vm.steps,
          options: _vm.stepOptions,
          callbacks: _vm.stepsCallback
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-65337818", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65337818","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ManageProject.vue
// module id = null
// module chunks = 